import { z } from 'zod';
import { idSchema, timestampsSchema } from './common';

export const evalSetSchema = z
  .object({
    id: idSchema,
    tenantId: idSchema,
    workspaceId: idSchema.nullish(),
    agentId: idSchema,
    name: z.string().min(1).max(200),
    description: z.string().max(2000).default(''),
    /** Minimum pass rate (0..1) required to ship a config change. */
    passThreshold: z.number().min(0).max(1).default(0.8),
  })
  .merge(timestampsSchema);
export type EvalSet = z.infer<typeof evalSetSchema>;

export const evalCaseSchema = z
  .object({
    id: idSchema,
    tenantId: idSchema,
    evalSetId: idSchema,
    input: z.string().min(1),
    /** Expected substrings/assertions; kept simple and provider-agnostic. */
    expectedContains: z.array(z.string()).default([]),
    rubric: z.string().max(4000).optional(),
  })
  .merge(timestampsSchema);
export type EvalCase = z.infer<typeof evalCaseSchema>;

export const evalResultDetailSchema = z.object({
  caseId: z.string(),
  passed: z.boolean(),
  output: z.string(),
  rubricScore: z.number().min(0).max(1).optional(),
  rubricReason: z.string().optional(),
});
export type EvalResultDetail = z.infer<typeof evalResultDetailSchema>;

export const evalResultSchema = z
  .object({
    id: idSchema,
    tenantId: idSchema,
    evalSetId: idSchema,
    agentId: idSchema.nullish(),
    runId: idSchema.nullish(),
    passRate: z.number().min(0).max(1),
    passed: z.boolean(),
    total: z.number().int().nonnegative(),
    details: z.array(evalResultDetailSchema).default([]),
  })
  .merge(timestampsSchema);
export type EvalResult = z.infer<typeof evalResultSchema>;
